
import { useState } from 'react';
import { useEffect } from 'react';
import React from 'react';
import { ArrowRightIcon, ArrowsLeftRightIcon, CardsThreeIcon, CurrencyDollarIcon, DotsThreeOutlineIcon, ExclamationMarkIcon, UsersIcon, WalletIcon } from '@phosphor-icons/react'
import { useTheme } from 'components/provider/theme';

interface StatsCardProps {
    title: string;
    icons?: React.ReactNode;
    iconsBackground?: string;
    value: string | number;
    compareValue?: string | number;
    compareType?: 'up' | 'down' | 'equal';
    valueType: 'number' | 'percent' | 'currency';
    option?: {
        debug: boolean;
        valueLine?: number;
        animation?: boolean;
        compareLine?: boolean;
    }
    className?: string;
}
const StatsCard: React.FC<StatsCardProps> = ({
    title,
    icons,
    iconsBackground = '#f0f0f0',
    value,
    compareValue,
    compareType,
    valueType,
    option = {
        debug: false,
        valueLine: 2,
        animation: true,
        compareLine: false
    },
    className = ''
}) => {


    const { theme } = useTheme()


    return (
        <div className={`flex flex-col p-4 ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white'} rounded-lg cursor-pointer shadow-lg justify-between  ${className} ${option.animation ? ' transition-all duration-300 hover:!shadow-2xl hover:!-translate-y-2' : ''}`}>
            <div className="flex flex-row items-center justify-between">
                <p className={`text-[20px] font-semibold ${theme === 'dark' ? 'bg-gray-800 text-gray-400' : 'bg-white'}`}>{title}</p>
                <div className={`bg-[${iconsBackground}] w-12 h-12 rounded-[8px] flex items-center justify-center`}>
                    {icons ? <div className="text-2xl ">{icons}</div> : <div className="text-2xl "><DotsThreeOutlineIcon size={24} /></div>}
                </div>
            </div>
            <div>
                <p className={`xl:text-[32px] lg:text-[24px] md:text-[18px] font-bold line-clamp-${option.valueLine || 2} !m-0`}>
                    {valueType === 'currency' ? '$' : ''}
                    {typeof value === 'number' ? value === 0 ? 'Updating..' : value.toLocaleString() : value}
                    {valueType === 'percent' ? '%' : ''}
                </p>
            </div>
            {
                option.compareLine && (
                    <div className="flex flex-row items-center justify-between mt-2">
                        <p className={`text-sm m-0 ${compareType === 'up' ? 'text-green-500' : compareType === 'down' ? 'text-red-500' : 'text-yellow-500'}`}>
                            <span
                                className={`inline-block transition-transform duration-500 ${compareType === 'up'
                                    ? 'rotate-[-45deg] animate-spin-slow'
                                    : compareType === 'down'
                                        ? 'rotate-[45deg] animate-spin-slow'
                                        : ''
                                    }`}
                            >
                                <ArrowRightIcon size={24} />
                            </span>
                            {valueType === 'currency' ? ' $' : ' '}
                            {Math.abs(Number(compareValue)).toLocaleString()}
                            {valueType === 'percent' ? '%' : ''}
                        </p>
                        <p className='text-sm text-gray-500 font-extralight m-0'>
                            Compared to last month
                        </p>
                    </div>
                )

            }
        </div>
    );
}

export default StatsCard;
export type { StatsCardProps };